import { Component, Input } from '@angular/core';
import { ConnectionService } from '@services/connection-service';
import {
  CallScheduledBottomsheetComponent,
} from '@shared/bottom-sheet-layouts/pending-call-bottomsheet/call-scheduled-bottomsheet/call-scheduled-bottomsheet.component';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { NgClass, NgIf } from '@angular/common';

@Component({
  selector: 'app-call-scheduled-banner',
  imports: [NgIf, NgClass],
  templateUrl: './call-scheduled-banner.component.html',
  standalone: true
})
export class CallScheduledBannerComponent {
  @Input() newUI: boolean = false;
  user: any;
  mobileNumber: string;
  internalUser: boolean = false;
  constructor(
    private readonly conn: ConnectionService,
    private readonly bottomSheet: MatBottomSheet,
  ) {
  }

  ngOnInit(): void {
    this.user = this.conn.getActingUser();
    this.mobileNumber = this.user?.get('MobileNumber');
    this.internalUser = this.conn.isInternalUser();
  }

  bannerClick(): void {
    const bottomSheet = this.bottomSheet.open(CallScheduledBottomsheetComponent, {});
    bottomSheet.backdropClick().subscribe((): void => {
      bottomSheet.dismiss();
    });
  }
}
